var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.component, ( _obj = {}, _obj[_vm.$style.active] = _vm.active, _obj )],on:{"click":_vm.handleClick}},[_c('div',{class:_vm.$style.image,style:({
      'background-image': ("url(" + _vm.image + ")"),
    })}),_c('div',{class:_vm.$style.details},[_c('span',{class:_vm.$style.name},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_c('span',{class:_vm.$style.description},[_vm._v(" "+_vm._s(_vm.description)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }